import { useQuery } from "@tanstack/react-query";

import { hatLeadsMenue, type OpenLeadItem } from "@shared/leads/leadsMenue";

import { apiGet } from "@/lib/api/client";
import { useAuth } from "@/lib/auth/AuthContext";
import { queryKeys } from "@/lib/query/keys";

// ---------------------------------------------------------------------------
// useOpenLeads — alle offenen Anfragen fuer das Menue «Leads» (LEAD-23)
// ---------------------------------------------------------------------------
// Laeuft nur fuer die, die das Menue haben (`hatLeadsMenue`, dieselbe Regel
// wie Leiste und Server) — die Buchhaltung holt hier keinen 403 ab. Der
// Schluessel liegt unter `leads`: jede Lead-Aktion (zuteilen, uebernehmen,
// absagen) raeumt ihn mit ab, ohne dass sie von dieser Liste wissen muss.

export interface OpenLeadsData {
  readonly leads: readonly OpenLeadItem[];
  /** LEAD-25: wer Anfragen entgegennimmt und verteilt — aus der Einstellung. */
  readonly koordinatorUserId: string | null;
  /** LEAD-25: Anfragen in der Ablage «Gelöscht». */
  readonly ablageAnzahl: number;
}

interface OpenLeadsResponse {
  ok: true;
  data: {
    leads: readonly OpenLeadItem[];
    generatedAt: string;
    koordinatorUserId?: string | null;
    ablageAnzahl?: number;
  };
}

export function useOpenLeads() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.leads.open(),
    enabled: hatLeadsMenue(user?.role),
    queryFn: async (): Promise<OpenLeadsData> => {
      const res = await apiGet<OpenLeadsResponse>("/api/projects/open-leads");
      // `?? null`: eine aeltere Server-Antwort traegt die Felder nicht.
      return {
        leads: res.data.leads,
        koordinatorUserId: res.data.koordinatorUserId ?? null,
        ablageAnzahl: res.data.ablageAnzahl ?? 0,
      };
    },
    // Arbeitstage und Fristen sind zeitabhaengig — derselbe Takt wie die
    // Kachel «Wer uebernimmt?».
    staleTime: 60_000,
  });
}
